module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IST OF")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROPOSITIONS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-head"
  }, [_vm._v("PART I: METHOD")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w35"
  }), _c('td', {
    staticClass: "w65"
  }, [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 1"), _c('br'), _vm._v("A Conception of Christian Theology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-1"
    }
  }, [_c('em', [_vm._v("Proposition #1")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-1"
    }
  }, [_vm._v("Christian theology is a practical wisdom that articulates a vision of God, the world, and ourselves in the service of a piety, a settled disposition, and a way of living.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-2"
    }
  }, [_c('em', [_vm._v("Proposition #2")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-2"
    }
  }, [_vm._v("Life in the world evokes wonder and mystery, and these evocations are integral to religious sensibility.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-3"
    }
  }, [_c('em', [_vm._v("Proposition #3")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-3"
    }
  }, [_vm._v("A deep basis for religious living and for participating in religious communities lies in affections or emotions that are taken to be responsive to the divine.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-4"
    }
  }, [_c('em', [_vm._v("Proposition #4")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-4"
    }
  }, [_vm._v("Generally speaking, affections emerge as we interact with other persons, objects, situations, and realities. They are intertwined with our knowledge of and beliefs about the many things with which we interact, and they influence and dispose us….")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-5"
    }
  }, [_c('em', [_vm._v("Proposition #5")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-5"
    }
  }, [_vm._v("Affections associated with a sense for the divine are evoked in the midst of our interactions with objects and others…. Unlike secularized people … religious people take certain affections to have a further referential element….")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-6"
    }
  }, [_c('em', [_vm._v("Proposition #6")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-6"
    }
  }, [_vm._v("Religious people interpret interactions and affections with the aid of resources furnished by particular communities of language, practice, and belief.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-7"
    }
  }, [_c('em', [_vm._v("Proposition #7")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-7"
    }
  }, [_vm._v("The interpretive resources furnished by religious communities are mythopoeic…. They make analogical and symbolic use of rather ordinary ideas and images … to portray the additional felt dimension that lies beyond the threshold.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-8"
    }
  }, [_c('em', [_vm._v("Preposition #8")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-8"
    }
  }, [_vm._v("The relationship between religious affections and communities is reciprocal and circular. Imaginative resources furnished by religious communities and traditions are … instruments by which religious inklings and affections come to expression and media that shape inklings and affections.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-9"
    }
  }, [_c('em', [_vm._v("Proposition #9")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-9"
    }
  }, [_vm._v("Religions may be distinguished by their organizing and paradigmatic proposals.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-10"
    }
  }, [_c('em', [_vm._v("Proposition #10")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-10"
    }
  }, [_vm._v("Different kinds of theological visions may be classified according to the ways … they portray the divine in relationship to us and to the many objects and others we interact with.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-11"
    }
  }, [_c('em', [_vm._v("Proposition #11")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-11"
    }
  }, [_vm._v("The mythopoeic discourses of polytheistic communities …")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-12"
    }
  }, [_c('em', [_vm._v("Proposition #12")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-12"
    }
  }, [_vm._v("The mythopoeic resources of monotheistic communities …")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-13"
    }
  }, [_c('em', [_vm._v("Proposition #13")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-13"
    }
  }, [_vm._v("Pantheistic theological visions …")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-14"
    }
  }, [_c('em', [_vm._v("Proposition #14")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-14"
    }
  }, [_vm._v("Christian communities bear monotheistic theological visions in which the event of redemption in Jesus Christ constitutes the paradigmatic proposal for picturing God, the world, and ourselves.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-15"
    }
  }, [_c('em', [_vm._v("Proposition #15")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-15"
    }
  }, [_vm._v("Christians who internalize the basic image/idea of God as Creator, Judge, and Redeemer find that it shapes and expresses their interpretations of the world and humanity as well as many of their salient attitudes and sensibilities.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-16"
    }
  }, [_c('em', [_vm._v("Proposition #16")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-16"
    }
  }, [_vm._v("A Christian theology presents a Christian community’s theological vision or wisdom and, as such, represents the disciplined development of the interpretive work of preaching.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-17"
    }
  }, [_c('em', [_vm._v("Proposition #17")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-17"
    }
  }, [_vm._v("As the disciplined development of a vision of God, the world, and ourselves, Christian theology strives to keep in touch with a community’s religious affections, symbols, and images…. It also tries to achieve a higher level of coherence and precision … to formulate a more general wisdom than is indicated by isolated symbols, images, and texts. The result is a kind of “in-between” discourse….")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-18"
    }
  }, [_c('em', [_vm._v("Proposition #18")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#prop-18"
    }
  }, [_vm._v("The disciplined formulation of a contemporary theological vision makes a number of additional reflections and inquiries possible…. Even so, Christian theological reflections retain their ecclesial and practical aim.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 2"), _c('br'), _vm._v("The Formation and Arrangement of Theological Statements")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #19")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Certain recurrent theological stances represent malformations of the Creator-Judge-Redeemer idea and also shape and express basic dispositions or pieties that have exceedingly negative consequences for faithful living.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #20")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional textbooks do not treat another recurrent malformation of theology and piety: anti-Judaism, a devaluation of Jewish religion that often mixes with anti-Semitism….")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #21")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Particular Christian subtraditions may articulate distinctive understandings of God as Creator-Judge-Redeemer that shape and express distinctive variations in piety and faithfulness.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #22")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The theology presented here emerges from the Reformed Christian subtradition.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #23")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The theology presented here is also indebted to an ecumenical and liberal strand of the Reformed tradition in North America that supports a social Christianity, is willing to revise inherited beliefs and practices in the light of new knowledge and inquiries, accepts plurality within both the Reformed tradition and the wider Christian movement, and appreciates the importance of conversations among world religions.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #24")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological statements or doctrines will be formulated with reference to the Scripture of the Old and New Testaments, church history or tradition … , contemporary knowledge, and consistency with other theological statements.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #25")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#prop-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("This book arranges doctrines systematically in order to pursue greater clarity, depth, and coherence.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-head"
  }, [_vm._v("PART II: CREATION")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 3"), _c('br'), _vm._v("The Constitution of the Dynamic World: Cosmic Ecology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#prop-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #26")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#prop-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God the Creator is God the Redeemer, and this equation has important consequences for the way we understand both creation and redemption.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#prop-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #27")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#prop-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The world is contingent.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#prop-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #28")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#prop-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creation is a formed and dynamic ensemble, and intricate and vast system, a set of orderings, or cosmic ecology.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#prop-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #29")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#prop-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The created world is good.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 4"), _c('br'), _vm._v("The Dynamic Continuation of the World: Cosmic Passage")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #30")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creation and sustenance go together.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #31")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The world and its ordering processes continue.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #32")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We have a place and a time within a vast cosmic passage.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #33")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The image of cosmic passage is compatible with a robust understanding of divine governance, but it encourages us to remain agnostic about what some theologians have meant by particular and special providence.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #34")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#prop-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The images of creation as cosmic ecology and of divine governance and sustenance manifest in an all-encompassing cosmic passage have implications for a view of redemption.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 5"), _c('br'), _vm._v("Created and Sustained Human Life")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #35")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Created and sustained human life is mysterious.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #36")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Created and sustained human life is a gift.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #37")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Created and sustained human life is socially inclined, institutionally sustained, and socially conditioned.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #38")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Created and sustained human life is capable and responsible.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-39",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #39")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Created and sustained human life is personal.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #40")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Created and sustained human life is historical.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-41",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #41")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#prop-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The chief end, calling, or vocation of created and sustained human beings in the midst of cosmic ecology and passage is to participate in true communion with God in community with others.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 6"), _c('br'), _vm._v("God the Creator")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-42",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #42")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological language is peculiar because God is not an object alongside other objects—and is not knowable as other objects are knowable.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-43",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #43")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creator and Sustainer or Governor are symbols that point to God with respect to the constitution and continuation of the world.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-44",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #44")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God is Creator.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-45",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #45")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God is Sustainer.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-46",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #46")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#prop-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God is the Real, whose fundamental tendency or trajectory is to ground, instigate, and shape a process of reality that we encounter as a dynamic order of grace, and that pushes us toward an ec-centric orientation in life.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-head"
  }, [_vm._v("PART III: REDEMPTION")])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 7"), _c('br'), _vm._v("Jesus Christ and the Covenant of Grace")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #47")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God the Redeemer is God the Creator, and this equation has important consequences for the way we understand both redemption and creation.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-48",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #48")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The event of Jesus Christ points to a Trinitarian dynamic.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #49")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus Christ fulfills the covenant of grace.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-50",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #50")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus is the Christ, the living Word and wisdom of God in a human life.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-51",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #51")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter07#prop-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus Christ is reconciler.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 8"), _c('br'), _vm._v("The Truth, the Way, and the Life")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#prop-52",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #52")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#prop-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus as the Christ teaches the truth.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#prop-53",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #53")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#prop-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ministry and mission of Jesus as the Christ embody and display a way or a manner in life that accords with the truth.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#prop-54",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #54")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#prop-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The crucifixion and continuing presence of Jesus as the Christ empower a manner or way in life that aligns with the truth.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 9"), _c('br'), _vm._v("The Spirit and the Church")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#prop-55",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #55")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#prop-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit gives and renews life.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#prop-56",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #56")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#prop-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit gathers the church and sends it on its mission.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#prop-57",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #57")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#prop-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The church that the Spirit gathers and sends is a community of worship.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 10"), _c('br'), _vm._v("Human Life: Sin and Regeneration")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-58",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #58")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("People stand in need of rehabilitation and renewal because they are mired in and diminished by a persistent fault.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-59",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #59")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sin’s corruption is multifaceted, radical, and universal.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-60",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #60")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For those who embrace the Word of the gospel, there is a transition from a previous constricted orientation to a new and ec-centric manner of life in Christ and the Spirit, and this transition is called regeneration.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-61",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #61")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before God, sinners may know themselves to be accepted and to have worth by grace through faith. This is justification.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-62",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #62")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By the grace of God and in the power of the Spirit, people may be caught up in a lifelong process of rehabilitation, regeneration, and renewal. This is sanctification.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-63",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #63")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The idea of calling and vocation helps to clarify the sanctifying formation of persons and communities toward ec-centric piety and existence in the world.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-64",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #64")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#prop-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hopeful realism names the practical stance in the world that comes to expression (among other places) in this understanding of calling and vocation, and that draws on a strain of piety intertwined with the symbolic ideas of creation, sin, and redemption.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 11"), _c('br'), _vm._v("The Fragmentation and Renewal of the World: Civil Government, Church, and Sustainability")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#prop-65",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #65")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#prop-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civil government is a historical means in and through which God’s sustenance and care are mediated to us, but all governments are subject to chronic corruptions, all fall short of the kingdom, and so all stand in need of criticism and reform. Occasionally, they also stand in need of fundamental reconfiguration.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#prop-66",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #66")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#prop-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The church is in, with, against, and for the world.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#prop-67",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #67")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#prop-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Current challenges posed by the effects of human activity on our planetary home and by the prospects for sustainability call for both realism and hope.")])])])]), _vm._v(" "), _c('tr', [_c('td'), _c('td', [_c('p', {
    staticClass: "pro-chap"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 12"), _c('br'), _vm._v("God the Redeemer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#prop-68",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #68")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#prop-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God is Redeemer.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#prop-69",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #69")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#prop-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God is the answer to the question of hope.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#prop-70",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Proposition #70")])])])]), _c('td', [_c('p', {
    staticClass: "proposition"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter12#prop-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God is love.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4be0d024","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_List_Propotions.vue
// module id = 72
// module chunks = 0